// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Templates[data-v-9a0b1b6a] {\n  width: 100%;\n  padding: 0 16px 40px;\n  display: flex;\n  flex-direction: column;\n}\n.Templates .body[data-v-9a0b1b6a] {\n  display: flex;\n  flex-direction: column;\n  margin-right: -40px;\n  margin-top: -16px;\n  height: 100%;\n  align-items: center;\n  justify-content: center;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
